module.exports = __webpack_public_path__ + "img/task_list.5b45b9bb.svg";